var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00781 20.5V11.5547H0V8H3.00781V5.1875C3.00781 3.70312 3.42448 2.55729 4.25781 1.75C5.09115 0.916667 6.19792 0.5 7.57812 0.5C8.69792 0.5 9.60938 0.552083 10.3125 0.65625V3.82031H8.4375C7.73438 3.82031 7.2526 3.97656 6.99219 4.28906C6.78385 4.54948 6.67969 4.96615 6.67969 5.53906V8H10L9.53125 11.5547H6.67969V20.5H3.00781Z",
    fill: "#1312DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.26b57d40e9503e4b3232d13f12f13aaa.svg";
export { ForwardRef as ReactComponent };